import { ITheme } from "../../utils/theme"

export const scrollTopButtonStyle = (theme: ITheme) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
})

export const iconStyle = (theme: ITheme) => ({
  fill: theme.palette.primary.main,
  opacity: 0.8,
  background: theme.palette.blue.A400,
  borderRadius: '50%',
  width: '35px',
  height: '35px'
})